import { Audience_Purchase_Time_Window, Audience_Status, Count_Products_By } from '@occc/graphql';

import { TargetingAttributesFormValues } from './types';

export enum AudienceTargetingAttribute {
  AgeWithin = 'AudienceAgeWithinTargetingAttribute',
  FuelAndConvenienceProfile = 'AudienceFuelAndConvenienceProfileConfiguration',
  InAnySegments = 'AudienceInAnySegmentsTargetingAttribute',
  NotInAnySegments = 'AudienceNotInAnySegmentsTargetingAttribute',
  InAllSegments = 'AudienceInAllSegmentsTargetingAttribute',
  PurchasedAtLeast = 'AudiencePurchasedAtLeastTargetingAttribute',
  PurchasedAtMost = 'AudiencePurchasedAtMostTargetingAttribute',
}

export const MAX_DAYS_IN_PAST = 90;

export const MIN_SELECTED_RETAILER_NETWORKS = 1;

export enum DynamicAudienceSection {
  purchases = 'purchases',
  fulfillments = 'fulfillments',
  offerActivations = 'offerActivations',
  memberAttributes = 'memberAttributes',
  walletSteeringItems = 'walletSteeringItems',
  segments = 'segments',
  qualifiedEvents = 'qualifiedEvents',
  surveys = 'surveys',
  combinedAudiences = 'combinedAudiences',
}
export type TargetingAttributesFormField = keyof TargetingAttributesFormValues;

export const sectionToFormFieldsMap: Record<
  DynamicAudienceSection,
  TargetingAttributesFormField[]
> = {
  [DynamicAudienceSection.walletSteeringItems]: ['walletSteeringItems'],
  [DynamicAudienceSection.purchases]: ['purchases'],
  [DynamicAudienceSection.qualifiedEvents]: ['qualifiedEvents'],
  [DynamicAudienceSection.fulfillments]: ['fulfillments'],
  [DynamicAudienceSection.offerActivations]: ['offerActivations'],
  [DynamicAudienceSection.memberAttributes]: [
    'behaviors',
    'communicationPreferences',
    'homeStore',
    'productInterests',
    'lastVisit',
    'pointBalance',
    'membershipCreated',
    'employeeTargetingAttributes',
    'ageWithin',
    'birthdayMonths',
    'externalIdentityVerification',
  ],
  [DynamicAudienceSection.segments]: ['segments'],
  [DynamicAudienceSection.surveys]: ['surveys'],
  [DynamicAudienceSection.combinedAudiences]: ['combinedAudiences'],
};

export const AUDIENCE_STATUS_ALL = 'ALL';

export const statusOptions = [
  { label: 'All Active + Draft', value: AUDIENCE_STATUS_ALL },
  { label: 'Active', value: Audience_Status.Active },
  { label: 'Draft', value: Audience_Status.Draft },
  { label: 'Archived', value: Audience_Status.Archived },
];

export const productCountingMap: Record<Count_Products_By, string> = {
  [Count_Products_By.MoneyAmount]: 'Money amount',
  [Count_Products_By.Quantity]: 'Quantity',
  [Count_Products_By.Visits]: 'Visits',
};

export const titleByTimeWindow: Record<Audience_Purchase_Time_Window, string> = {
  [Audience_Purchase_Time_Window.Last_7Days]: 'Last 7 days',
  [Audience_Purchase_Time_Window.Last_14Days]: 'Last 14 days',
  [Audience_Purchase_Time_Window.Last_30Days]: 'Last 30 days',
  [Audience_Purchase_Time_Window.Last_60Days]: 'Last 60 days',
  [Audience_Purchase_Time_Window.Last_90Days]: 'Last 90 days',
};
